import React from "react";
import { useLang } from "../LanguageContext";

const SERVICE_URL =
  process.env.REACT_APP_REMOTE_TIMER_URL ||
  "https://my-remote-timer-347621148423.europe-north1.run.app";

function RemoteTimer() {
  const { t } = useLang();
  return (
    <div className="iframe-page">
      <div className="page-section-header">
        <span className="section-label">{t("remoteTimer.label")}</span>
        <div className="subhead">{t("remoteTimer.title")}</div>
        <p className="section-intro-inner">{t("remoteTimer.intro")}</p>
      </div>
      <div className="iframe-container">
        <iframe src={SERVICE_URL} title={t("remoteTimer.title")} allowFullScreen />
      </div>
    </div>
  );
}

export default RemoteTimer;
